// Subscription management functionality

// Configuration using theme settings with fallbacks
const MINICART_CONFIG = {
    STAY_SELLING_PLAN_ID: window.FDMinicartSubscriptionsConfig.staySellingPlanId, // DEV fallback
    CROSS_SELL_PLAN_ID: window.FDMinicartSubscriptionsConfig.crossSellPlanId,
    TRYNOW_SELLING_PLAN_ID: window.FDMinicartSubscriptionsConfig.tryNowSellingPlanId,
    ADD_ON_SUBSCRIPTION_PLAN_ID: window.FDMinicartSubscriptionsConfig.addOnSubscriptionPlanId
};
window.MINICART_CONFIG = MINICART_CONFIG;

// Add items to cart function
function postAdd(itemsData) {
    var pageAdd = typeof updateCartDisplay === 'function' && window.FDCartPageAdd
        ? window.FDCartPageAdd.begin([])
        : null;
    window.addToCart(itemsData)
    .then(response => response.json().then(data => {
        if (!response.ok) {
            var addError = new Error(data.description || data.message || 'Add failed');
            addError.data = data;
            throw addError;
        }
        return data;
    }))
    .then(() => {
        if (typeof updateCartDisplay !== 'function') return null;
        return window.FDCartApi
            ? window.FDCartApi.getCart(true)
            : fetch('/cart.js').then(function (response) { return response.json(); });
    })
    .then(function (updatedCart) {
        if (!updatedCart) return null;
        if (typeof toggleCartOpen === 'function') {
            toggleCartOpen();
        }

        var painted = pageAdd ? pageAdd.confirm(updatedCart) : updateCartDisplay(updatedCart);

        if (typeof updateCartCount === 'function') {
            updateCartCount(updatedCart.item_count);
        }

        var cartContent = document.querySelector('.firstday-cart__flyout-content.has-items');
        if (cartContent) {
            cartContent.scrollTop = 0;
        }
        return painted;
    })
    .catch(error => {
        console.error('Error adding items to cart:', error);
        if (pageAdd) pageAdd.fail(error);
    });
}

// Plan-upgrade props for a line that is about to become a subscription, so they
// go out in the same write as the selling plan (FDCartApi.backfillPlanUpgrade
// would add them in a second write). Null when the line would not get them.
function planUpgradePropsForSubscribe(cart, item, sellingPlanId) {
    const ctx = window.FDCartContext;
    if (!ctx || typeof ctx.findPlanUpgradeSeed !== 'function' || !cart || !Array.isArray(cart.items) || !item) return null;
    const seed = ctx.findPlanUpgradeSeed(cart.items);
    if (!seed) return null;
    const asSubscription = Object.assign({}, item, { selling_plan: sellingPlanId, selling_plan_allocation: undefined });
    if (!ctx.isEligibleForPlanUpgradeCopy(asSubscription, seed)) return null;
    const stamped = { properties: {} };
    Object.keys(item.properties || {}).forEach(function (key) {
        if (item.properties[key] != null) stamped.properties[key] = item.properties[key];
    });
    return ctx.copyPlanUpgradeProps(stamped, seed) ? stamped.properties : null;
}

// Upgrade item to subscription
async function upgradeToSubscription(itemKey) {
    // Find the button that was clicked
    let button = null;

    // Try to get from event first
    if (typeof event !== 'undefined' && event && event.target) {
        button = event.target.closest('button');
    }

    // Fallback to querySelector
    if (!button) {
        const escapedKey = itemKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/'/g, "\\'");
        button = document.querySelector(`[onclick*="upgradeToSubscription"][onclick*="${escapedKey}"]`);
    }

    // The button goes at once (subscription lines have none); the line price and
    // the totals wait for the server price. The line stays inert until then.
    const subscribeLook = function (article) {
        article.querySelectorAll('.firstday-cart__flyout-item-subscription').forEach(function (wrap) {
            wrap.style.display = 'none';
        });
        article.classList.add('is-subscription');
        article.classList.remove('is-onetime');
        article.querySelectorAll('.firstday-cart__flyout-item-price').forEach(function (block) {
            block.classList.add('fd-cart-price-pending');
        });
    };
    const buttonWrap = button && button.closest('.firstday-cart__flyout-item-subscription');
    const releaseLine = typeof holdLine === 'function' ? holdLine(itemKey, subscribeLook) : function () {};
    if (typeof holdLine !== 'function') {
        if (buttonWrap) buttonWrap.style.display = 'none';
        const article = button && button.closest('[data-remove-key]');
        if (article) subscribeLook(article);
    }
    let writeOpen = typeof beginCartWrite === 'function';
    if (writeOpen) beginCartWrite();
    const closeWrite = function () {
        if (writeOpen) endCartWrite();
        writeOpen = false;
    };

    // True when Shopify refused the plan write, so the cart is as last confirmed.
    let cartUnchanged = false;

    // Runs after the quantity writes already on their way, so it sends the
    // quantity the drawer shows.
    const task = async function () {
        let currentQuantity = null;
        let matchingItem = null;
        let cartData = null;
        // Prefer the selling plan stamped on the line by ATC
        // (_if_upgrade__selling_plan_id), which is product/option-specific.
        // Reads legacy _selling_plan_id too. Falls back to theme STAY only when
        // nothing was stamped (older carts).
        let resolvedSellingPlanId = MINICART_CONFIG.STAY_SELLING_PLAN_ID;

        try {
            cartData = window.FDCart && window.FDCart.getCart()
                ? window.FDCart.getCart()
                : await (window.FDCartApi
                    ? window.FDCartApi.getCart(false)
                    : fetch('/cart.js').then(r => r.json()));

            if (cartData && Array.isArray(cartData.items)) {
                matchingItem = cartData.items.find(item => item.key === itemKey) || null;
                if (matchingItem) {
                    currentQuantity = matchingItem.quantity;
                    const stampedPlanId = matchingItem.properties && (matchingItem.properties._if_upgrade__selling_plan_id || matchingItem.properties._selling_plan_id);
                    if (stampedPlanId) {
                        resolvedSellingPlanId = String(stampedPlanId);
                    }
                }
            }
        } catch (cartError) {
            console.warn('Could not determine current quantity for subscription upgrade:', cartError);
        }

        const changePayload = {
            id: itemKey,
            selling_plan: resolvedSellingPlanId
        };

        if (typeof currentQuantity === 'number') {
            changePayload.quantity = currentQuantity;
        }

        // Sending properties replaces the line's whole map: only from a cart known to
        // match the server, else the backfill adds them in a second write as before.
        const cartIsCurrent = Boolean(window.FDCart && typeof window.FDCart.isCartCurrent === 'function' &&
            window.FDCart.isCartCurrent(cartData));
        const planUpgradeProps = typeof currentQuantity === 'number' && cartIsCurrent
            ? planUpgradePropsForSubscribe(cartData, matchingItem, resolvedSellingPlanId)
            : null;
        if (planUpgradeProps) changePayload.properties = planUpgradeProps;

        // Update the existing cart item to include the selling plan
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(changePayload)
        });

        let updatedCart = await response.json();
        if (!response.ok) {
            cartUnchanged = true;
            const err = new Error(updatedCart.description || updatedCart.message || 'Cart Error');
            err.status = response.status;
            err.data = updatedCart;
            throw err;
        }

        // The props were sent before Shopify named the plan. A 60 or 90 day plan
        // does not take them, so put the line's own props back.
        if (planUpgradeProps && window.FDCartContext && Array.isArray(updatedCart.items)) {
            const seed = window.FDCartContext.findPlanUpgradeSeed(cartData.items);
            const line = updatedCart.items.find(function (item) {
                const props = item.properties || {};
                return String(item.variant_id) === String(matchingItem.variant_id) &&
                    props._plan_upgrade_to === planUpgradeProps._plan_upgrade_to &&
                    String((item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || '') === String(resolvedSellingPlanId);
            });
            const unstamped = line ? Object.assign({}, line, { properties: matchingItem.properties || {} }) : null;
            if (line && seed && !window.FDCartContext.isEligibleForPlanUpgradeCopy(unstamped, seed) && window.FDCartApi) {
                const ownProps = {};
                Object.keys(matchingItem.properties || {}).forEach(function (key) {
                    if (matchingItem.properties[key] != null) ownProps[key] = matchingItem.properties[key];
                });
                updatedCart = await window.FDCartApi.changeLine(line.key, line.quantity, { properties: ownProps });
            }
        }

        closeWrite();
        releaseLine();
        if (typeof updateCartDisplay === 'function') {
            await updateCartDisplay(updatedCart);
        }

        // ACCESSIBILITY: Announce subscription upgrade to screen readers
        if (typeof window.announceToScreenReader === 'function') {
            // Find the product title from the updated cart
            const item = updatedCart.items?.find(i => i.key === itemKey);
            const productTitle = item?.product_title || matchingItem?.product_title || 'Item';
            window.announceToScreenReader(`${productTitle} converted to subscription. Additional savings applied.`);
        }
    };
    const action = typeof runLineAction === 'function' ? runLineAction(task) : task();

    try {
        await (typeof trackDrawerAction === 'function' ? trackDrawerAction(action) : action);
    } catch (error) {
        console.error('Error upgrading to subscription:', error);
        closeWrite();
        releaseLine();
        if (buttonWrap) buttonWrap.style.removeProperty('display');
        if (cartUnchanged && typeof rollbackDrawer === 'function') {
            await rollbackDrawer(null);
        } else if (typeof repaintFromServer === 'function') {
            await repaintFromServer();
        } else if (window.FDCartApi) {
            window.FDCartApi.getCart(true).then(function (cart) {
                if (typeof updateCartDisplay === 'function') updateCartDisplay(cart);
            });
        }
        if (typeof window.announceToScreenReader === 'function') {
            window.announceToScreenReader('Error upgrading to subscription. Please try again.', 'assertive');
        }
    }
}

// Downgrade subscription to one-time purchase
function downgradeToOneTime(itemKey) {
    // Remove the selling plan from the existing cart item
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: itemKey,
            selling_plan: null
        })
    })
    .then(response => response.json())
    .then(updatedCart => {
        console.log('Successfully downgraded from subscription:', updatedCart);
        if (typeof updateCartDisplay === 'function') {
            updateCartDisplay(updatedCart);
        }
    })
    .catch(error => {
        console.error('Error downgrading from subscription:', error);
        // Fallback: refresh the page to show updated cart
        window.location.reload();
    });
}


// Get subscription savings message
function getSubscriptionSavingsMessage(item) {
    if (!item.selling_plan_allocation) {
        return 'Subscribe & Save 15%';
    }

    const originalPrice = item.original_price || item.price;
    const currentPrice = item.price;
    const savings = ((originalPrice - currentPrice) / originalPrice * 100).toFixed(0);

    return `Subscribed - Saving ${savings}%`;
}

// Handle subscription frequency changes
function updateSubscriptionFrequency(itemKey, newPlanId) {
    // Update the selling plan of the existing cart item
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: itemKey,
            selling_plan: newPlanId
        })
    })
    .then(response => response.json())
    .then(updatedCart => {
        console.log('Successfully updated subscription frequency:', updatedCart);
        if (typeof updateCartDisplay === 'function') {
            updateCartDisplay(updatedCart);
        }
    })
    .catch(error => {
        console.error('Error updating subscription frequency:', error);
        // Fallback: refresh the page to show updated cart
        window.location.reload();
    });
}
